import { Suspense } from "react";
import Countdown from "./Countdown";
import fetchNextPerformance from "./utils/fetchNextPerformance";

export default function App() {
    const performance = fetchNextPerformance();
    return <Suspense fallback={<p>Loading...</p>}>
        <Countdown performance={performance} />
    </Suspense>
}